export default __webpack_public_path__ + "static/media/EM0520.34I-22658_-15130_0.bad1c47f.jpg";